module.exports = __webpack_public_path__ + "img/new-shipment.7dd5420a.svg";